import { formatDateByTimezone } from '../../app/helpers/date'
/**
 * AddDiscountCampaignCtrl controller
 * Add/edit partner Product
 */

// controller mixins
AddDiscountCampaignCtrl.mixes = [
  ['m2mCtrlMixin', 'dc', 'subscriptions']
]

/**
 * AddDiscountCampaignCtrl controller
 *
 * @class AddDiscountCampaignCtrl
 * @memberof mwApp/discountCampaign
 * @see mwApp/discountCampaign
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/discountCampaign.controller:AddDiscountCampaignCtrl
 */
/* @ngInject */
export default function AddDiscountCampaignCtrl ($scope, $location, $uibModal, $http, alertLiteSvc, authSvc, DiscountCampaign, NetworkCurrency, Subscription, dc, pckg) {
  var vm = this
  vm.isNew = dc._isNew()
  vm.viewMode = !authSvc.hasAccess('editDiscountCampaigns') || dc.status === 'EXPIRED'
  if (vm.isNew && authSvc.hasAccess('createDiscountCampaigns')) {
    vm.viewMode = false
  }

  vm.selectProduct = function () {
    vm.selectSubscription(vm.subscriptionSelected)
  }

  vm.dc = dc
  if (!vm.viewMode) {
    DiscountCampaign.getExtra(pckg.id).then(subscriptions => {
      vm.subscriptions = subscriptions.filter(s => {
        return !dc.subscriptions.find(ds => ds.id === s.id)
      })
    })
  }
  NetworkCurrency.loadAll({ network: pckg }).then(res => {
    const currencies = res.filter(cur => cur.enabled)
    vm.defaultCurrency = currencies.length ? currencies[0].name : ''
  })

  vm.discount_campaign_statuses = {
    UPCOMING: 'Upcoming',
    EXPIRED: 'Expired',
    ACTIVE: 'Active'
  }

  vm.updateStatus = function (status) {
    DiscountCampaign.load({ id: dc.id, networkId: pckg.id }).then(({ subscriptions }) => {
      $uibModal.open({
        templateUrl: 'components/packages/popups/discountCampaignErrorModal.html',
        controller: 'DiscountCampaignErrorModalCtrl as vm',
        windowClass: 'modal-class-conflict',
        backdrop: true,
        animation: false,
        resolve: {
          currentSubscriptions: function () {
            return status === 'EXPIRE' ? [] : subscriptions
          },
          newSubscriptions: function () {
            return []
          },
          activate: function () {
            return status === 'ACTIVATE'
          },
          expire: function () {
            return status !== 'ACTIVATE'
          },
          dc: function () {
            return vm.dc
          },
          networkId: function () {
            return pckg.id
          }
        }
      })
        .result
        .then(
          function close () {
            $http.patch(vm.dc._url, status === 'ACTIVATE' ? '"ACTIVATE"' : '"EXPIRE"')
              .then(() => {
                setTimeout(() => {
                  dc._update().then(() => {
                    vm.viewMode = dc.status === 'EXPIRED'
                  })
                  alertLiteSvc.alert('Status updated successfully', 'success')
                }, 1000)
              })
              .catch((err) => {
                alertLiteSvc.alertError(err)
              })
          },
          function dismiss () {
          })
    })
  }

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  vm.verifyCode = function () {
    DiscountCampaign.checkingUniqCode(pckg.id, vm.dc.code).then(res => {
      vm.discountCodeChecked = true
      vm.verifyingError = res
    })
  }

  // huck for disabling enter button e
  setTimeout(() => {
    document.getElementById('applyTo').addEventListener('keydown', (event) => {
      if (event.key === 'e') {
        event.preventDefault()
        event.stopPropagation()
      }
    })
    document.getElementById('applyFrom').addEventListener('keydown', (event) => {
      if (event.key === 'e') {
        event.preventDefault()
        event.stopPropagation()
      }
    })
    document.getElementById('value').addEventListener('keydown', (event) => {
      if (event.key === 'e') {
        event.preventDefault()
        event.stopPropagation()
      }
    })
  }, 1000)

  /**
   * "From" datepicker settings
   *
   * @memberof mwApp/discountCampaign.controller:AddDiscountCampaignCtrl
 */
  vm.dpCfg = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    changeHandler: function (form, field) {
      if (field) {
        form[field].$setTouched()
      } else {
        form.dateFrom.$setTouched()
        form.dateTo.$setTouched()
      }
      const startDate = vm.dc.$startDate && vm.dc.$startDate?.setHours(vm.dc.$startTime?.getHours() || 0, vm.dc.$startTime?.getMinutes() || 0)
      const endDate = vm.dc.$endDate && vm.dc.$endDate?.setHours(vm.dc.$endTime?.getHours() || 0, vm.dc.$endTime?.getMinutes() || 0)
      const minDateStart = startDate > formatDateByTimezone(Date.now(), false).valueOf()
      const minDateEnd = endDate > formatDateByTimezone(Date.now(), false).valueOf()
      if (field === 'dateFrom' || !field) {
        if (vm.dc.startNow) {
          vm.dc.$startTime = vm.dc.$startTime ? vm.dc.$startTime : new Date()
          form.dateTo.$setValidity('earlier', true)
          form.dateTo.$setValidity('earlier', true)
          form.dateFrom.$setValidity('after', true)
          form.dateFrom.$setValidity('earlier', true)
          form.dateFrom.$setValidity('minDate', true)
          form.timeFrom.$setValidity('time', true)
        } else {
          form.dateFrom.$setValidity('minDate', minDateStart)
          form.dateFrom.$setValidity('after', true)

          if (startDate && endDate) {
            const after = endDate > startDate
            if (vm.dc.$unlimitedPeriod) {
              form.dateFrom.$setValidity('after', true)
              form.dateTo.$setValidity('earlier', true)
            } else {
              if (form.dateTo.$error && form.dateTo.$error.earlier === true) {
                form.dateTo.$setValidity('earlier', after)
              }
              form.dateFrom.$setValidity('after', after)
            }
          }
        }
      }
      if (field === 'dateTo' || !field) {
        if (vm.dc.$unlimitedPeriod) {
          vm.dc.$endTime = vm.dc.$endTime ? vm.dc.$endTime : new Date()
          form.dateFrom.$setValidity('after', true)
          form.dateFrom.$setValidity('earlier', true)
          form.dateTo.$setValidity('after', true)
          form.dateTo.$setValidity('earlier', true)
          form.dateTo.$setValidity('minDate', true)
          form.timeTo.$setValidity('time', true)
        } else {
          form.dateTo.$setValidity('minDate', minDateEnd)
          form.dateTo.$setValidity('earlie', true)

          if (vm.dc.startNow) {
            form.dateTo.$setValidity('after', true)
            form.dateFrom.$setValidity('earlier', true)
          } else {
            if (startDate && endDate) {
              const earlier = endDate > startDate
              if (form.dateFrom.$error && form.dateFrom.$error.after === true) {
                form.dateFrom.$setValidity('after', earlier)
              }
              form.dateTo.$setValidity('earlier', earlier)
            }
          }
        }
      }
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/discountCampaign.controller:AddDiscountCampaignCtrl
   */
  vm.openFrom = function () {
    vm.dpCfg.fromOpened = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/discountCampaign.controller:AddDiscountCampaignCtrl
   */
  vm.openTo = function () {
    vm.dpCfg.toOpened = true
  }

  vm.autoPayFilter = function (el) {
    if (vm.dc.applyToRecurringPayments) {
      return el.autoPay
    }
    return true
  }

  /**
   * Save Discount Campaign
   *
   * @memberof mwApp/discountCampaign.controller:AddDiscountCampaignCtrl
   */
  vm.submit = function (form) {
    if (vm.isNew) {
      vm.dpCfg.changeHandler(form)
      if (!vm.discountCodeChecked || vm.verifyingError) {
        return
      }
    }
    if (vm.dc.status === 'UPCOMING' && form.code.$dirty) {
      if (!vm.discountCodeChecked || vm.verifyingError) {
        return
      }
    }

    if (form.$invalid) {
      return
    }
    vm.setDisable()
    dc._save(null, null, '', '', true)
      .then(() => {
        dc._update()
        form.$setPristine()
        $location.url(pckg._publicUrl + '/discount-campaigns/' + dc.id)
      })
      .catch((err) => {
        if (err.data.includes('Subscription')) {
          const newSubscriptions = vm.dc.subscriptions.filter((s) => !vm.dc.$cachedSubscriptionIds.includes(s.id))
          $uibModal.open({
            templateUrl: 'components/packages/popups/discountCampaignErrorModal.html',
            controller: 'DiscountCampaignErrorModalCtrl as vm',
            windowClass: 'modal-class-conflict',
            backdrop: true,
            animation: false,
            resolve: {
              currentSubscriptions: function () {
                if (vm.isNew) {
                  return []
                }
                return DiscountCampaign.load({ id: dc.id, networkId: pckg.id }).then(({ subscriptions }) => subscriptions)
              },
              newSubscriptions: function () {
                if (newSubscriptions.length) {
                  return Subscription.loadAll({ networkId: pckg.id })
                    .then(data => data.filter(item => item.subscriptionType === 'Subscription'))
                    .then(subscriptions => {
                      newSubscriptions.forEach(s => {
                        const currentSubscription = subscriptions.find(sub => sub.id === s.id)
                        if (currentSubscription) {
                          s.autoPay = currentSubscription.autoPay
                          s.free = currentSubscription.free
                          s.enabled = currentSubscription.enabled
                        } else {
                          s.deleted = true
                        }
                      })
                      return newSubscriptions
                    })
                }
                return []
              },
              activate: function () {
                return false
              },
              expire: function () {
                return false
              },
              dc: function () {
                return vm.dc
              },
              networkId: function () {
                return pckg.id
              }
            }
          })
            .result
            .then(
              function close () {
              },
              function dismiss () {
              })
        } else {
          alertLiteSvc.alertError(err)
        }
      })
      .finally(vm.unsetDisable)
  }

  vm.clearSubscriptions = function (form) {
    const cachedSubscriptions = angular.copy(vm.dc.subscriptions)
    cachedSubscriptions.forEach((sub) => {
      vm.deselectSubscription(sub, form)
    })
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/discountCampaign.controller:AddDiscountCampaignCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(pckg._publicUrl + '/discount-campaigns')
    }
  }

  vm.disabledSave = function () {
    return !vm.discountCodeChecked || vm.verifyingError
  }

  vm.handleChangeApply = function (field, form) {
    if (vm.dc.status === 'ACTIVE') {
      switch (field) {
        case 'from':
          form.applyFrom.$setValidity('range', vm.dc.applyFrom <= vm.dc.$cachedApplyFrom)
          break
        case 'to':
          form.applyTo.$setValidity('range', vm.dc.applyTo >= vm.dc.$cachedApplyTo)
      }
    }
  }

  vm.minApplyTo = function (message = false) {
    if (message) {
      return (!vm.dc.applyFrom || vm.dc.applyFrom < 2) ? 2 : vm.dc.applyFrom
    }
    return (vm.dc.applyToRecurringPayments && !vm.dc.$unlimitedApply) ? (!vm.dc.applyFrom || vm.dc.applyFrom < 2) ? 2 : vm.dc.applyFrom : null
  }

  $scope.$watch('vm.dc.subscriptions.length', () => {
    if (vm.dc.subscriptions.length) {
      let subscriptionsCurrencies = vm.dc.subscriptions.map(s => s.currency)
      subscriptionsCurrencies = Array.from(new Set(subscriptionsCurrencies)).filter(currency => currency)
      vm.mappedCurrency = subscriptionsCurrencies.join('/')
    } else {
      vm.mappedCurrency = null
    }
  })

  $scope.$watch('vm.dc.code', () => {
    vm.discountCodeChecked = false
  })
}
